import { createContext, useContext, useRef, useState, useEffect, useMemo, memo, createElement, cloneElement, Component } from 'react';
import '../../../prop-types/index.js';
import { TooltipProvider as M, Tooltip as F } from '../../tooltip/dist/nivo-tooltip.es.js';
import merge_1 from '../../../lodash/merge.js';
import get_1 from '../../../lodash/get.js';
import set_1 from '../../../lodash/set.js';
import '../../../d3-color/src/color.js';
import '../../../d3-color/src/lab.js';
import '../../../d3-color/src/cubehelix.js';
import './../external_lib/d3-interpolate/src/rgb.js';
import R from './../external_lib/d3-interpolate/src/string.js';
import './../external_lib/d3-interpolate/src/zoom.js';
import './../external_lib/d3-interpolate/src/cubehelix.js';
import { a as animated } from '../../../@react-spring/web/dist/react-spring_web.modern.js';
import isString_1 from '../../../lodash/isString.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import last_1 from '../../../lodash/last.js';
import '../../../d3-array/dist/d3-array.js';
import ordinal from '../../../d3-scale/src/ordinal.js';
import '../../../d3-interpolate/dist/d3-interpolate.js';
import './../../../d3-scale/external_lib/d3-format/src/defaultLocale.js';
import './../../../d3-scale/external_lib/d3-format/src/formatSpecifier.js';
import '../../../d3-time/src/millisecond.js';
import '../../../d3-time/src/second.js';
import '../../../d3-time/src/minute.js';
import '../../../d3-time/src/hour.js';
import '../../../d3-time/src/day.js';
import '../../../d3-time/src/week.js';
import '../../../d3-time/src/month.js';
import '../../../d3-time/src/year.js';
import '../../../d3-time/src/utcMinute.js';
import '../../../d3-time/src/utcHour.js';
import '../../../d3-time/src/utcDay.js';
import '../../../d3-time/src/utcWeek.js';
import '../../../d3-time/src/utcMonth.js';
import '../../../d3-time/src/utcYear.js';
import { timeFormat } from '../../../d3-time-format/src/defaultLocale.js';
import '../../../d3-time-format/src/isoFormat.js';
import '../../../d3-time-format/src/isoParse.js';
import ae from './../external_lib/d3-scale-chromatic/src/categorical/category10.js';
import le from './../external_lib/d3-scale-chromatic/src/categorical/Accent.js';
import se from './../external_lib/d3-scale-chromatic/src/categorical/Dark2.js';
import './../external_lib/d3-scale-chromatic/src/categorical/observable10.js';
import de from './../external_lib/d3-scale-chromatic/src/categorical/Paired.js';
import ue from './../external_lib/d3-scale-chromatic/src/categorical/Pastel1.js';
import ce from './../external_lib/d3-scale-chromatic/src/categorical/Pastel2.js';
import fe from './../external_lib/d3-scale-chromatic/src/categorical/Set1.js';
import pe from './../external_lib/d3-scale-chromatic/src/categorical/Set2.js';
import he from './../external_lib/d3-scale-chromatic/src/categorical/Set3.js';
import './../external_lib/d3-scale-chromatic/src/categorical/Tableau10.js';
import { scheme } from './../external_lib/d3-scale-chromatic/src/diverging/BrBG.js';
import { scheme as scheme$1 } from './../external_lib/d3-scale-chromatic/src/diverging/PRGn.js';
import { scheme as scheme$2 } from './../external_lib/d3-scale-chromatic/src/diverging/PiYG.js';
import { scheme as scheme$3 } from './../external_lib/d3-scale-chromatic/src/diverging/PuOr.js';
import { scheme as scheme$4 } from './../external_lib/d3-scale-chromatic/src/diverging/RdBu.js';
import { scheme as scheme$5 } from './../external_lib/d3-scale-chromatic/src/diverging/RdGy.js';
import { scheme as scheme$6 } from './../external_lib/d3-scale-chromatic/src/diverging/RdYlBu.js';
import { scheme as scheme$7 } from './../external_lib/d3-scale-chromatic/src/diverging/RdYlGn.js';
import { scheme as scheme$8 } from './../external_lib/d3-scale-chromatic/src/diverging/Spectral.js';
import { scheme as scheme$f } from './../external_lib/d3-scale-chromatic/src/sequential-multi/BuGn.js';
import { scheme as scheme$g } from './../external_lib/d3-scale-chromatic/src/sequential-multi/BuPu.js';
import { scheme as scheme$h } from './../external_lib/d3-scale-chromatic/src/sequential-multi/GnBu.js';
import { scheme as scheme$i } from './../external_lib/d3-scale-chromatic/src/sequential-multi/OrRd.js';
import { scheme as scheme$j } from './../external_lib/d3-scale-chromatic/src/sequential-multi/PuBuGn.js';
import { scheme as scheme$k } from './../external_lib/d3-scale-chromatic/src/sequential-multi/PuBu.js';
import { scheme as scheme$l } from './../external_lib/d3-scale-chromatic/src/sequential-multi/PuRd.js';
import { scheme as scheme$m } from './../external_lib/d3-scale-chromatic/src/sequential-multi/RdPu.js';
import { scheme as scheme$n } from './../external_lib/d3-scale-chromatic/src/sequential-multi/YlGnBu.js';
import { scheme as scheme$o } from './../external_lib/d3-scale-chromatic/src/sequential-multi/YlGn.js';
import { scheme as scheme$p } from './../external_lib/d3-scale-chromatic/src/sequential-multi/YlOrBr.js';
import { scheme as scheme$q } from './../external_lib/d3-scale-chromatic/src/sequential-multi/YlOrRd.js';
import { scheme as scheme$9 } from './../external_lib/d3-scale-chromatic/src/sequential-single/Blues.js';
import { scheme as scheme$a } from './../external_lib/d3-scale-chromatic/src/sequential-single/Greens.js';
import { scheme as scheme$b } from './../external_lib/d3-scale-chromatic/src/sequential-single/Greys.js';
import { scheme as scheme$d } from './../external_lib/d3-scale-chromatic/src/sequential-single/Purples.js';
import { scheme as scheme$e } from './../external_lib/d3-scale-chromatic/src/sequential-single/Reds.js';
import { scheme as scheme$c } from './../external_lib/d3-scale-chromatic/src/sequential-single/Oranges.js';
import './../external_lib/d3-scale-chromatic/src/sequential-multi/cubehelix.js';
import './../external_lib/d3-scale-chromatic/src/sequential-multi/rainbow.js';
import './../external_lib/d3-scale-chromatic/src/sequential-multi/sinebow.js';
import './../external_lib/d3-scale-chromatic/src/sequential-multi/viridis.js';
import isFunction_1 from '../../../lodash/isFunction.js';
import without_1 from '../../../lodash/without.js';
import '../../../d3-path/src/path.js';
import curveLinear from '../../../d3-shape/src/curve/linear.js';
import er from '../../../d3-shape/src/curve/basisClosed.js';
import rr from '../../../d3-shape/src/curve/basisOpen.js';
import $e from '../../../d3-shape/src/curve/basis.js';
import tr from '../../../d3-shape/src/curve/bundle.js';
import nr from '../../../d3-shape/src/curve/cardinalClosed.js';
import or from '../../../d3-shape/src/curve/cardinalOpen.js';
import ir from '../../../d3-shape/src/curve/cardinal.js';
import lr from '../../../d3-shape/src/curve/catmullRomClosed.js';
import sr from '../../../d3-shape/src/curve/catmullRomOpen.js';
import ar from '../../../d3-shape/src/curve/catmullRom.js';
import ur from '../../../d3-shape/src/curve/linearClosed.js';
import { monotoneX, monotoneY } from '../../../d3-shape/src/curve/monotone.js';
import pr from '../../../d3-shape/src/curve/natural.js';
import hr, { stepAfter, stepBefore } from '../../../d3-shape/src/curve/step.js';
import wr from '../../../d3-shape/src/offset/none.js';
import Rr from '../../../d3-shape/src/order/none.js';
import kr from '../../../d3-shape/src/offset/expand.js';
import j from '../../../d3-shape/src/offset/diverging.js';
import xr from '../../../d3-shape/src/offset/silhouette.js';
import Or from '../../../d3-shape/src/offset/wiggle.js';
import mr from '../../../d3-shape/src/order/ascending.js';
import yr from '../../../d3-shape/src/order/descending.js';
import vr from '../../../d3-shape/src/order/insideOut.js';
import qr from '../../../d3-shape/src/order/reverse.js';
import { format } from '../../../d3-format/src/defaultLocale.js';
import '../../../d3-format/src/formatSpecifier.js';
import isPlainObject_1 from '../../../lodash/isPlainObject.js';
import pick_1 from '../../../lodash/pick.js';
import isEqual_1 from '../../../lodash/isEqual.js';
import { exports as propTypesExports } from '../../../../_virtual/index2.js';
import { config, useSpring, to } from '../../../@react-spring/core/dist/react-spring_core.modern.js';
function Sr() {
  return Sr = Object.assign ? Object.assign.bind() : function (e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Sr.apply(this, arguments);
}
function Mr(e, r) {
  return Mr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, r) {
    return e.__proto__ = r, e;
  }, Mr(e, r);
}
function jr(e, r) {
  if (null == e) return {};
  var t,
    i,
    n = {},
    o = Object.keys(e);
  for (i = 0; i < o.length; i++) t = o[i], r.indexOf(t) >= 0 || (n[t] = e[t]);
  return n;
}
var Br = {
    fill: propTypesExports.string,
    fontSize: propTypesExports.number,
    fontFamily: propTypesExports.string
  },
  Gr = propTypesExports.shape({
    domain: propTypesExports.shape({
      line: propTypesExports.shape({
        stroke: propTypesExports.string.isRequired,
        strokeWidth: propTypesExports.number.isRequired,
        strokeDasharray: propTypesExports.string
      }).isRequired
    }).isRequired,
    ticks: propTypesExports.shape({
      line: propTypesExports.shape({
        stroke: propTypesExports.string.isRequired,
        strokeWidth: propTypesExports.number.isRequired,
        strokeDasharray: propTypesExports.string
      }).isRequired,
      text: propTypesExports.shape(Sr({}, Br)).isRequired
    }).isRequired,
    legend: propTypesExports.shape({
      text: propTypesExports.shape(Sr({}, Br)).isRequired
    }).isRequired
  }),
  Lr = propTypesExports.shape({
    line: propTypesExports.shape({
      stroke: propTypesExports.string.isRequired,
      strokeWidth: propTypesExports.number.isRequired,
      strokeDasharray: propTypesExports.string
    }).isRequired
  }),
  Ir = propTypesExports.shape({
    hidden: propTypesExports.shape({
      symbol: propTypesExports.shape({
        fill: propTypesExports.string.isRequired,
        opacity: propTypesExports.number
      }).isRequired,
      text: propTypesExports.shape(Sr({}, Br, {
        opacity: propTypesExports.number
      })).isRequired
    }).isRequired,
    text: propTypesExports.shape(Sr({}, Br)).isRequired
  }),
  Dr = propTypesExports.shape({
    text: propTypesExports.shape(Sr({}, Br)).isRequired
  }),
  Yr = propTypesExports.shape({
    text: propTypesExports.shape(Sr({}, Br)).isRequired
  }),
  Ar = propTypesExports.shape({
    text: propTypesExports.shape(Sr({}, Br)).isRequired
  }),
  Fr = propTypesExports.shape({
    line: propTypesExports.shape({
      stroke: propTypesExports.string.isRequired,
      strokeWidth: propTypesExports.number.isRequired,
      strokeDasharray: propTypesExports.string
    }).isRequired
  }),
  Er = propTypesExports.shape({
    text: propTypesExports.shape(Sr({}, Br, {
      outlineWidth: propTypesExports.number.isRequired,
      outlineColor: propTypesExports.string.isRequired
    })).isRequired,
    link: propTypesExports.shape({
      stroke: propTypesExports.string.isRequired,
      strokeWidth: propTypesExports.number.isRequired,
      outlineWidth: propTypesExports.number.isRequired,
      outlineColor: propTypesExports.string.isRequired
    }).isRequired,
    outline: propTypesExports.shape({
      stroke: propTypesExports.string.isRequired,
      strokeWidth: propTypesExports.number.isRequired,
      outlineWidth: propTypesExports.number.isRequired,
      outlineColor: propTypesExports.string.isRequired
    }).isRequired,
    symbol: propTypesExports.shape({
      fill: propTypesExports.string.isRequired,
      outlineWidth: propTypesExports.number.isRequired,
      outlineColor: propTypesExports.string.isRequired
    }).isRequired
  });
propTypesExports.shape({
  background: propTypesExports.string.isRequired,
  fontFamily: propTypesExports.string.isRequired,
  fontSize: propTypesExports.number.isRequired,
  textColor: propTypesExports.string.isRequired,
  axis: Gr.isRequired,
  grid: Lr.isRequired,
  legends: Ir.isRequired,
  labels: Dr.isRequired,
  dots: Yr.isRequired,
  markers: Ar,
  crosshair: Fr.isRequired,
  annotations: Er.isRequired
});
var Xr = {
    background: "transparent",
    text: {
      fontFamily: "sans-serif",
      fontSize: 11,
      fill: "#333333",
      outlineWidth: 0,
      outlineColor: "transparent"
    },
    axis: {
      domain: {
        line: {
          stroke: "transparent",
          strokeWidth: 1
        }
      },
      ticks: {
        line: {
          stroke: "#777777",
          strokeWidth: 1
        },
        text: {}
      },
      legend: {
        text: {
          fontSize: 12
        }
      }
    },
    grid: {
      line: {
        stroke: "#dddddd",
        strokeWidth: 1
      }
    },
    legends: {
      hidden: {
        symbol: {
          fill: "#333333",
          opacity: .6
        },
        text: {
          fill: "#333333",
          opacity: .6
        }
      },
      text: {},
      ticks: {
        line: {
          stroke: "#777777",
          strokeWidth: 1
        },
        text: {
          fontSize: 10
        }
      },
      title: {
        text: {}
      }
    },
    labels: {
      text: {}
    },
    markers: {
      lineColor: "#000000",
      lineStrokeWidth: 1,
      text: {}
    },
    dots: {
      text: {}
    },
    tooltip: {
      container: {
        background: "white",
        color: "inherit",
        fontSize: "inherit",
        borderRadius: "2px",
        boxShadow: "0 1px 2px rgba(0, 0, 0, 0.25)",
        padding: "5px 9px"
      },
      basic: {
        whiteSpace: "pre",
        display: "flex",
        alignItems: "center"
      },
      chip: {
        marginRight: 7
      },
      table: {},
      tableCell: {
        padding: "3px 5px"
      },
      tableCellValue: {
        fontWeight: "bold"
      }
    },
    crosshair: {
      line: {
        stroke: "#000000",
        strokeWidth: 1,
        strokeOpacity: .75,
        strokeDasharray: "6 6"
      }
    },
    annotations: {
      text: {
        fontSize: 13,
        outlineWidth: 2,
        outlineColor: "#ffffff",
        outlineOpacity: 1
      },
      link: {
        stroke: "#000000",
        strokeWidth: 1,
        outlineWidth: 2,
        outlineColor: "#ffffff",
        outlineOpacity: 1
      },
      outline: {
        fill: "none",
        stroke: "#000000",
        strokeWidth: 2,
        outlineWidth: 2,
        outlineColor: "#ffffff",
        outlineOpacity: 1
      },
      symbol: {
        fill: "#000000",
        outlineWidth: 2,
        outlineColor: "#ffffff",
        outlineOpacity: 1
      }
    }
  },
  Hr = ["axis.ticks.text", "axis.legend.text", "legends.title.text", "legends.text", "legends.ticks.text", "legends.title.text", "labels.text", "dots.text", "markers.text", "annotations.text"],
  Kr = function (e, r) {
    var t = merge_1({}, e, r);
    return Hr.forEach(function (e) {
      void 0 === get_1(t, e + ".fontFamily") && set_1(t, e + ".fontFamily", t.text.fontFamily), void 0 === get_1(t, e + ".fontSize") && set_1(t, e + ".fontSize", t.text.fontSize), void 0 === get_1(t, e + ".fill") && set_1(t, e + ".fill", t.text.fill), void 0 === get_1(t, e + ".outlineWidth") && set_1(t, e + ".outlineWidth", t.text.outlineWidth), void 0 === get_1(t, e + ".outlineColor") && set_1(t, e + ".outlineColor", t.text.outlineColor);
    }), t;
  },
  Nr = createContext(),
  Vr = function (e) {
    var t = e.children,
      i = e.animate,
      n = e.config,
      o = useMemo(function () {
        var e = isString_1(n) ? config[n] : n;
        return {
          animate: i,
          config: e
        };
      }, [i, n]);
    return jsx(Nr.Provider, {
      value: o,
      children: t
    });
  },
  Jr = {
    animate: propTypesExports.bool,
    motionConfig: propTypesExports.oneOfType([propTypesExports.oneOf(Object.keys(config)), propTypesExports.shape({
      mass: propTypesExports.number,
      tension: propTypesExports.number,
      friction: propTypesExports.number,
      clamp: propTypesExports.bool,
      precision: propTypesExports.number,
      velocity: propTypesExports.number,
      duration: propTypesExports.number,
      easing: propTypesExports.func
    })])
  };
Vr.propTypes = {
  children: propTypesExports.node.isRequired,
  animate: Jr.animate,
  config: Jr.motionConfig
};
var Qr = {
  animate: !0,
  config: "default"
};
Vr.defaultProps = Qr;
var Zr = function () {
    return useContext(Nr);
  },
  $r = function (e) {
    var t = Zr(),
      o = t.animate,
      a = t.config,
      l = function (e) {
        var r = useRef();
        return useEffect(function () {
          r.current = e;
        }, [e]), r.current;
      }(e),
      s = useMemo(function () {
        return R(l, e);
      }, [l, e]),
      d = useSpring({
        from: {
          value: 0
        },
        to: {
          value: 1
        },
        reset: !0,
        config: a,
        immediate: !o
      }).value;
    return to(d, s);
  },
  et = {
    nivo: ["#d76445", "#f47560", "#e8c1a0", "#97e3d5", "#61cdbb", "#00b0a7"],
    BrBG: last_1(scheme),
    PRGn: last_1(scheme$1),
    PiYG: last_1(scheme$2),
    PuOr: last_1(scheme$3),
    RdBu: last_1(scheme$4),
    RdGy: last_1(scheme$5),
    RdYlBu: last_1(scheme$6),
    RdYlGn: last_1(scheme$7),
    spectral: last_1(scheme$8),
    blues: last_1(scheme$9),
    greens: last_1(scheme$a),
    greys: last_1(scheme$b),
    oranges: last_1(scheme$c),
    purples: last_1(scheme$d),
    reds: last_1(scheme$e),
    BuGn: last_1(scheme$f),
    BuPu: last_1(scheme$g),
    GnBu: last_1(scheme$h),
    OrRd: last_1(scheme$i),
    PuBuGn: last_1(scheme$j),
    PuBu: last_1(scheme$k),
    PuRd: last_1(scheme$l),
    RdPu: last_1(scheme$m),
    YlGnBu: last_1(scheme$n),
    YlGn: last_1(scheme$o),
    YlOrBr: last_1(scheme$p),
    YlOrRd: last_1(scheme$q)
  },
  rt = Object.keys(et);
({
  nivo: ["#e8c1a0", "#f47560", "#f1e15b", "#e8a838", "#61cdbb", "#97e3d5"],
  category10: ae,
  accent: le,
  dark2: se,
  paired: de,
  pastel1: ue,
  pastel2: ce,
  set1: fe,
  set2: pe,
  set3: he,
  brown_blueGreen: last_1(scheme),
  purpleRed_green: last_1(scheme$1),
  pink_yellowGreen: last_1(scheme$2),
  purple_orange: last_1(scheme$3),
  red_blue: last_1(scheme$4),
  red_grey: last_1(scheme$5),
  red_yellow_blue: last_1(scheme$6),
  red_yellow_green: last_1(scheme$7),
  spectral: last_1(scheme$8),
  blues: last_1(scheme$9),
  greens: last_1(scheme$a),
  greys: last_1(scheme$b),
  oranges: last_1(scheme$c),
  purples: last_1(scheme$d),
  reds: last_1(scheme$e),
  blue_green: last_1(scheme$f),
  blue_purple: last_1(scheme$g),
  green_blue: last_1(scheme$h),
  orange_red: last_1(scheme$i),
  purple_blue_green: last_1(scheme$j),
  purple_blue: last_1(scheme$k),
  purple_red: last_1(scheme$l),
  red_purple: last_1(scheme$m),
  yellow_green_blue: last_1(scheme$n),
  yellow_green: last_1(scheme$o),
  yellow_orange_brown: last_1(scheme$p),
  yellow_orange_red: last_1(scheme$q)
});
propTypesExports.oneOfType([propTypesExports.oneOf(rt), propTypesExports.func, propTypesExports.arrayOf(propTypesExports.string)]);
var ut = {
    basis: $e,
    basisClosed: er,
    basisOpen: rr,
    bundle: tr,
    cardinal: ir,
    cardinalClosed: nr,
    cardinalOpen: or,
    catmullRom: ar,
    catmullRomClosed: lr,
    catmullRomOpen: sr,
    linear: curveLinear,
    linearClosed: ur,
    monotoneX: monotoneX,
    monotoneY: monotoneY,
    natural: pr,
    step: hr,
    stepAfter: stepAfter,
    stepBefore: stepBefore
  },
  ct = Object.keys(ut);
propTypesExports.oneOf(ct);
ct.filter(function (e) {
  return e.endsWith("Closed");
});
without_1(ct, "bundle", "basisClosed", "basisOpen", "cardinalClosed", "cardinalOpen", "catmullRomClosed", "catmullRomOpen", "linearClosed");
var gt = without_1(ct, "bundle", "basisClosed", "basisOpen", "cardinalClosed", "cardinalOpen", "catmullRomClosed", "catmullRomOpen", "linearClosed"),
  bt = propTypesExports.oneOf(gt),
  mt = function (e) {
    if (!ut[e]) throw new TypeError("'" + e + "', is not a valid curve interpolator identifier.");
    return ut[e];
  },
  yt = {
    defs: propTypesExports.arrayOf(propTypesExports.shape({
      id: propTypesExports.string.isRequired
    })).isRequired,
    fill: propTypesExports.arrayOf(propTypesExports.shape({
      id: propTypesExports.string.isRequired,
      match: propTypesExports.oneOfType([propTypesExports.oneOf(["*"]), propTypesExports.object, propTypesExports.func]).isRequired
    })).isRequired
  },
  vt = {
    ascending: mr,
    descending: yr,
    insideOut: vr,
    none: Rr,
    reverse: qr
  },
  Rt = Object.keys(vt);
propTypesExports.oneOf(Rt);
var _t = {
    expand: kr,
    diverging: j,
    none: wr,
    silhouette: xr,
    wiggle: Or
  },
  wt = Object.keys(_t);
propTypesExports.oneOf(wt);
propTypesExports.shape({
  top: propTypesExports.number,
  right: propTypesExports.number,
  bottom: propTypesExports.number,
  left: propTypesExports.number
}).isRequired;
var Ct = ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"],
  zt = propTypesExports.oneOf(Ct);
ordinal(he);
var jt = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  Bt = function (e, t, i) {
    return void 0 === i && (i = {}), useMemo(function () {
      var r = Sr({}, jt, i);
      return {
        margin: r,
        innerWidth: e - r.left - r.right,
        innerHeight: t - r.top - r.bottom,
        outerWidth: e,
        outerHeight: t
      };
    }, [e, t, i.top, i.right, i.bottom, i.left]);
  },
  Gt = function () {
    var e = useRef(null),
      r = useState({
        left: 0,
        top: 0,
        width: 0,
        height: 0
      }),
      t = r[0],
      a = r[1],
      l = useState(function () {
        return "undefined" == typeof ResizeObserver ? null : new ResizeObserver(function (e) {
          var r = e[0];
          return a(r.contentRect);
        });
      })[0];
    return useEffect(function () {
      return e.current && null !== l && l.observe(e.current), function () {
        null !== l && l.disconnect();
      };
    }, []), [e, t];
  },
  Lt = function (e) {
    return useMemo(function () {
      return Kr(Xr, e);
    }, [e]);
  },
  It = function (e) {
    return "function" == typeof e ? e : "string" == typeof e ? 0 === e.indexOf("time:") ? timeFormat(e.slice("5")) : format(e) : function (e) {
      return "" + e;
    };
  },
  Dt = function (e) {
    return useMemo(function () {
      return It(e);
    }, [e]);
  },
  Yt = createContext(),
  At = {},
  Ft = function (e) {
    var r = e.theme,
      t = void 0 === r ? At : r,
      i = e.children,
      n = Lt(t);
    return jsx(Yt.Provider, {
      value: n,
      children: i
    });
  };
Ft.propTypes = {
  children: propTypesExports.node.isRequired,
  theme: propTypesExports.object
};
var Et = function () {
    return useContext(Yt);
  },
  Ut = function (e) {
    var r = e.children,
      t = e.condition,
      i = e.wrapper;
    return t ? cloneElement(i, {}, r) : r;
  };
Ut.propTypes = {
  children: propTypesExports.node.isRequired,
  condition: propTypesExports.bool.isRequired,
  wrapper: propTypesExports.element.isRequired
};
var Xt = {
    position: "relative"
  },
  Ht = function (e) {
    var r = e.children,
      t = e.theme,
      n = e.renderWrapper,
      o = void 0 === n || n,
      a = e.isInteractive,
      l = void 0 === a || a,
      s = e.animate,
      d = e.motionConfig,
      u = useRef(null);
    return jsx(Ft, {
      theme: t,
      children: jsx(Vr, {
        animate: s,
        config: d,
        children: jsx(M, {
          container: u,
          children: jsxs(Ut, {
            condition: o,
            wrapper: jsx("div", {
              style: Xt,
              ref: u
            }),
            children: [r, l && jsx(F, {})]
          })
        })
      })
    });
  };
Ht.propTypes = {
  children: propTypesExports.element.isRequired,
  isInteractive: propTypesExports.bool,
  renderWrapper: propTypesExports.bool,
  theme: propTypesExports.object,
  animate: propTypesExports.bool,
  motionConfig: propTypesExports.string
};
({
  children: propTypesExports.func.isRequired,
  isInteractive: propTypesExports.bool,
  renderWrapper: propTypesExports.bool,
  theme: propTypesExports.object.isRequired,
  animate: propTypesExports.bool.isRequired,
  motionConfig: propTypesExports.string
});
var Jt = function (e) {
  var r = e.children,
    t = Gt(),
    i = t[0],
    n = t[1],
    o = n.width > 0 && n.height > 0;
  return jsx("div", {
    ref: i,
    style: {
      width: "100%",
      height: "100%"
    },
    children: o && r({
      width: n.width,
      height: n.height
    })
  });
};
Jt.propTypes = {
  children: propTypesExports.func.isRequired
};
var Qt = ["id", "colors"],
  Zt = function (e) {
    var r = e.id,
      t = e.colors,
      i = jr(e, Qt);
    return jsx("linearGradient", Sr({
      id: r,
      x1: 0,
      x2: 0,
      y1: 0,
      y2: 1
    }, i, {
      children: t.map(function (e) {
        var r = e.offset,
          t = e.color,
          i = e.opacity;
        return jsx("stop", {
          offset: r + "%",
          stopColor: t,
          stopOpacity: void 0 !== i ? i : 1
        }, r);
      })
    }));
  };
Zt.propTypes = {
  id: propTypesExports.string.isRequired,
  colors: propTypesExports.arrayOf(propTypesExports.shape({
    offset: propTypesExports.number.isRequired,
    color: propTypesExports.string.isRequired,
    opacity: propTypesExports.number
  })).isRequired,
  gradientTransform: propTypesExports.string
};
var ei = {
    linearGradient: Zt
  },
  ri = memo(function (e) {
    var r = e.id,
      t = e.background,
      i = e.color,
      n = e.size,
      o = e.padding,
      a = e.stagger,
      l = n + o,
      s = n / 2,
      d = o / 2;
    return !0 === a && (l = 2 * n + 2 * o), jsxs("pattern", {
      id: r,
      width: l,
      height: l,
      patternUnits: "userSpaceOnUse",
      children: [jsx("rect", {
        width: l,
        height: l,
        fill: t
      }), jsx("circle", {
        cx: d + s,
        cy: d + s,
        r: s,
        fill: i
      }), a && jsx("circle", {
        cx: 1.5 * o + n + s,
        cy: 1.5 * o + n + s,
        r: s,
        fill: i
      })]
    });
  });
ri.displayName = "PatternDots", ri.propTypes = {
  id: propTypesExports.string.isRequired,
  color: propTypesExports.string.isRequired,
  background: propTypesExports.string.isRequired,
  size: propTypesExports.number.isRequired,
  padding: propTypesExports.number.isRequired,
  stagger: propTypesExports.bool.isRequired
}, ri.defaultProps = {
  color: "#000000",
  background: "#ffffff",
  size: 4,
  padding: 4,
  stagger: !1
};
var ni = function (e) {
    return e * Math.PI / 180;
  },
  oi = function (e) {
    return 180 * e / Math.PI;
  },
  ai = function (e) {
    return e.startAngle + (e.endAngle - e.startAngle) / 2;
  },
  li = function (e, r) {
    return {
      x: Math.cos(e) * r,
      y: Math.sin(e) * r
    };
  },
  si = function (e) {
    var r = e % 360;
    return r < 0 && (r += 360), r;
  },
  fi = {
    svg: {
      align: {
        left: "start",
        center: "middle",
        right: "end",
        start: "start",
        middle: "middle",
        end: "end"
      },
      baseline: {
        top: "text-before-edge",
        center: "central",
        bottom: "alphabetic"
      }
    },
    canvas: {
      align: {
        left: "left",
        center: "center",
        right: "right",
        start: "left",
        middle: "center",
        end: "right"
      },
      baseline: {
        top: "top",
        center: "middle",
        bottom: "bottom"
      }
    }
  },
  hi = memo(function (e) {
    var r = e.id,
      t = e.spacing,
      i = e.rotation,
      n = e.background,
      o = e.color,
      a = e.lineWidth,
      l = Math.round(i) % 360,
      s = Math.abs(t);
    l > 180 ? l -= 360 : l > 90 ? l -= 180 : l < -180 ? l += 360 : l < -90 && (l += 180);
    var d,
      u = s,
      c = s;
    return 0 === l ? d = "\n                M 0 0 L " + u + " 0\n                M 0 " + c + " L " + u + " " + c + "\n            " : 90 === l ? d = "\n                M 0 0 L 0 " + c + "\n                M " + u + " 0 L " + u + " " + c + "\n            " : (u = Math.abs(s / Math.sin(ni(l))), c = s / Math.sin(ni(90 - l)), d = l > 0 ? "\n                    M 0 " + -c + " L " + 2 * u + " " + c + "\n                    M " + -u + " " + -c + " L " + u + " " + c + "\n                    M " + -u + " 0 L " + u + " " + 2 * c + "\n                " : "\n                    M " + -u + " " + c + " L " + u + " " + -c + "\n                    M " + -u + " " + 2 * c + " L " + 2 * u + " " + -c + "\n                    M 0 " + 2 * c + " L " + 2 * u + " 0\n                "), jsxs("pattern", {
      id: r,
      width: u,
      height: c,
      patternUnits: "userSpaceOnUse",
      children: [jsx("rect", {
        width: u,
        height: c,
        fill: n,
        stroke: "rgba(255, 0, 0, 0.1)",
        strokeWidth: 0
      }), jsx("path", {
        d: d,
        strokeWidth: a,
        stroke: o,
        strokeLinecap: "square"
      })]
    });
  });
hi.displayName = "PatternLines", hi.propTypes = {
  id: propTypesExports.string.isRequired,
  spacing: propTypesExports.number.isRequired,
  rotation: propTypesExports.number.isRequired,
  background: propTypesExports.string.isRequired,
  color: propTypesExports.string.isRequired,
  lineWidth: propTypesExports.number.isRequired
}, hi.defaultProps = {
  spacing: 5,
  rotation: 0,
  color: "#000000",
  background: "#ffffff",
  lineWidth: 2
};
var bi = memo(function (e) {
  var r = e.id,
    t = e.background,
    i = e.color,
    n = e.size,
    o = e.padding,
    a = e.stagger,
    l = n + o,
    s = o / 2;
  return !0 === a && (l = 2 * n + 2 * o), jsxs("pattern", {
    id: r,
    width: l,
    height: l,
    patternUnits: "userSpaceOnUse",
    children: [jsx("rect", {
      width: l,
      height: l,
      fill: t
    }), jsx("rect", {
      x: s,
      y: s,
      width: n,
      height: n,
      fill: i
    }), a && jsx("rect", {
      x: 1.5 * o + n,
      y: 1.5 * o + n,
      width: n,
      height: n,
      fill: i
    })]
  });
});
bi.displayName = "PatternSquares", bi.propTypes = {
  id: propTypesExports.string.isRequired,
  color: propTypesExports.string.isRequired,
  background: propTypesExports.string.isRequired,
  size: propTypesExports.number.isRequired,
  padding: propTypesExports.number.isRequired,
  stagger: propTypesExports.bool.isRequired
}, bi.defaultProps = {
  color: "#000000",
  background: "#ffffff",
  size: 4,
  padding: 4,
  stagger: !1
};
var yi = {
    patternDots: ri,
    patternLines: hi,
    patternSquares: bi
  },
  vi = ["type"],
  Ri = Sr({}, ei, yi),
  qi = function (e) {
    var r = e.defs;
    return !r || r.length < 1 ? null : jsx("defs", {
      "aria-hidden": !0,
      children: r.map(function (e) {
        var r = e.type,
          t = jr(e, vi);
        return Ri[r] ? createElement(Ri[r], Sr({
          key: t.id
        }, t)) : null;
      })
    });
  };
qi.propTypes = {
  defs: propTypesExports.arrayOf(propTypesExports.shape({
    type: propTypesExports.oneOf(Object.keys(Ri)).isRequired,
    id: propTypesExports.string.isRequired
  }))
};
var ki = memo(qi),
  _i = function (e) {
    var r = e.width,
      t = e.height,
      i = e.margin,
      n = e.defs,
      o = e.children,
      a = e.role,
      l = e.ariaLabel,
      s = e.ariaLabelledBy,
      d = e.ariaDescribedBy,
      u = e.isFocusable,
      c = Et();
    return jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: r,
      height: t,
      role: a,
      "aria-label": l,
      "aria-labelledby": s,
      "aria-describedby": d,
      focusable: u,
      tabIndex: u ? 0 : void 0,
      children: [jsx(ki, {
        defs: n
      }), jsx("rect", {
        width: r,
        height: t,
        fill: c.background
      }), jsx("g", {
        transform: "translate(" + i.left + "," + i.top + ")",
        children: o
      })]
    });
  };
_i.propTypes = {
  width: propTypesExports.number.isRequired,
  height: propTypesExports.number.isRequired,
  margin: propTypesExports.shape({
    top: propTypesExports.number.isRequired,
    left: propTypesExports.number.isRequired
  }).isRequired,
  defs: propTypesExports.array,
  children: propTypesExports.oneOfType([propTypesExports.arrayOf(propTypesExports.node), propTypesExports.node]).isRequired,
  role: propTypesExports.string,
  isFocusable: propTypesExports.bool,
  ariaLabel: propTypesExports.string,
  ariaLabelledBy: propTypesExports.string,
  ariaDescribedBy: propTypesExports.string
};
var wi = function (e) {
  var r = e.size,
    t = e.color,
    i = e.borderWidth,
    n = e.borderColor;
  return jsx("circle", {
    r: r / 2,
    fill: t,
    stroke: n,
    strokeWidth: i,
    style: {
      pointerEvents: "none"
    }
  });
};
wi.propTypes = {
  size: propTypesExports.number.isRequired,
  color: propTypesExports.string.isRequired,
  borderWidth: propTypesExports.number.isRequired,
  borderColor: propTypesExports.string.isRequired
};
var xi = memo(wi),
  Oi = function (e) {
    var r = e.x,
      t = e.y,
      i = e.symbol,
      n = void 0 === i ? xi : i,
      o = e.size,
      a = e.datum,
      l = e.color,
      s = e.borderWidth,
      u = e.borderColor,
      c = e.label,
      f = e.labelTextAnchor,
      p = void 0 === f ? "middle" : f,
      h = e.labelYOffset,
      g = void 0 === h ? -12 : h,
      b = Et(),
      m = Zr(),
      y = m.animate,
      v = m.config,
      R = useSpring({
        transform: "translate(" + r + ", " + t + ")",
        config: v,
        immediate: !y
      });
    return jsxs(animated.g, {
      transform: R.transform,
      style: {
        pointerEvents: "none"
      },
      children: [createElement(n, {
        size: o,
        color: l,
        datum: a,
        borderWidth: s,
        borderColor: u
      }), c && jsx("text", {
        textAnchor: p,
        y: g,
        style: b.dots.text,
        children: c
      })]
    });
  };
Oi.propTypes = {
  x: propTypesExports.number.isRequired,
  y: propTypesExports.number.isRequired,
  datum: propTypesExports.object.isRequired,
  size: propTypesExports.number.isRequired,
  color: propTypesExports.string.isRequired,
  borderWidth: propTypesExports.number.isRequired,
  borderColor: propTypesExports.string.isRequired,
  symbol: propTypesExports.oneOfType([propTypesExports.func, propTypesExports.object]),
  label: propTypesExports.oneOfType([propTypesExports.string, propTypesExports.number]),
  labelTextAnchor: propTypesExports.oneOf(["start", "middle", "end"]),
  labelYOffset: propTypesExports.number
};
var Wi = memo(Oi),
  Ci = function (e) {
    var r = e.width,
      t = e.height,
      i = e.axis,
      n = e.scale,
      o = e.value,
      a = e.lineStyle,
      l = e.textStyle,
      s = e.legend,
      d = e.legendPosition,
      u = e.legendOffsetX,
      c = e.legendOffsetY,
      f = e.legendOrientation,
      p = Et(),
      h = 0,
      g = 0,
      b = 0,
      m = 0;
    "y" === i ? (b = n(o), g = r) : (h = n(o), m = t);
    var y = null;
    if (s) {
      var v = function (e) {
        var r = e.axis,
          t = e.width,
          i = e.height,
          n = e.position,
          o = e.offsetX,
          a = e.offsetY,
          l = e.orientation,
          s = 0,
          d = 0,
          u = "vertical" === l ? -90 : 0,
          c = "start";
        if ("x" === r) switch (n) {
          case "top-left":
            s = -o, d = a, c = "end";
            break;
          case "top":
            d = -a, c = "horizontal" === l ? "middle" : "start";
            break;
          case "top-right":
            s = o, d = a, c = "horizontal" === l ? "start" : "end";
            break;
          case "right":
            s = o, d = i / 2, c = "horizontal" === l ? "start" : "middle";
            break;
          case "bottom-right":
            s = o, d = i - a, c = "start";
            break;
          case "bottom":
            d = i + a, c = "horizontal" === l ? "middle" : "end";
            break;
          case "bottom-left":
            d = i - a, s = -o, c = "horizontal" === l ? "end" : "start";
            break;
          case "left":
            s = -o, d = i / 2, c = "horizontal" === l ? "end" : "middle";
        } else switch (n) {
          case "top-left":
            s = o, d = -a, c = "start";
            break;
          case "top":
            s = t / 2, d = -a, c = "horizontal" === l ? "middle" : "start";
            break;
          case "top-right":
            s = t - o, d = -a, c = "horizontal" === l ? "end" : "start";
            break;
          case "right":
            s = t + o, c = "horizontal" === l ? "start" : "middle";
            break;
          case "bottom-right":
            s = t - o, d = a, c = "end";
            break;
          case "bottom":
            s = t / 2, d = a, c = "horizontal" === l ? "middle" : "end";
            break;
          case "bottom-left":
            s = o, d = a, c = "horizontal" === l ? "start" : "end";
            break;
          case "left":
            s = -o, c = "horizontal" === l ? "end" : "middle";
        }
        return {
          x: s,
          y: d,
          rotation: u,
          textAnchor: c
        };
      }({
        axis: i,
        width: r,
        height: t,
        position: d,
        offsetX: u,
        offsetY: c,
        orientation: f
      });
      y = jsx("text", {
        transform: "translate(" + v.x + ", " + v.y + ") rotate(" + v.rotation + ")",
        textAnchor: v.textAnchor,
        dominantBaseline: "central",
        style: l,
        children: s
      });
    }
    return jsxs("g", {
      transform: "translate(" + h + ", " + b + ")",
      children: [jsx("line", {
        x1: 0,
        x2: g,
        y1: 0,
        y2: m,
        stroke: p.markers.lineColor,
        strokeWidth: p.markers.lineStrokeWidth,
        style: a
      }), y]
    });
  };
Ci.propTypes = {
  width: propTypesExports.number.isRequired,
  height: propTypesExports.number.isRequired,
  axis: propTypesExports.oneOf(["x", "y"]).isRequired,
  scale: propTypesExports.func.isRequired,
  value: propTypesExports.oneOfType([propTypesExports.number, propTypesExports.string, propTypesExports.instanceOf(Date)]).isRequired,
  lineStyle: propTypesExports.object,
  textStyle: propTypesExports.object,
  legend: propTypesExports.string,
  legendPosition: propTypesExports.oneOf(["top-left", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left"]),
  legendOffsetX: propTypesExports.number.isRequired,
  legendOffsetY: propTypesExports.number.isRequired,
  legendOrientation: propTypesExports.oneOf(["horizontal", "vertical"]).isRequired
}, Ci.defaultProps = {
  legendPosition: "top-right",
  legendOffsetX: 14,
  legendOffsetY: 14,
  legendOrientation: "horizontal"
};
var zi = memo(Ci),
  Pi = function (e) {
    var r = e.markers,
      t = e.width,
      i = e.height,
      n = e.xScale,
      o = e.yScale;
    return r && 0 !== r.length ? r.map(function (e, r) {
      return jsx(zi, Sr({}, e, {
        width: t,
        height: i,
        scale: "y" === e.axis ? o : n
      }), r);
    }) : null;
  };
Pi.propTypes = {
  width: propTypesExports.number.isRequired,
  height: propTypesExports.number.isRequired,
  xScale: propTypesExports.func.isRequired,
  yScale: propTypesExports.func.isRequired,
  markers: propTypesExports.arrayOf(propTypesExports.shape({
    axis: propTypesExports.oneOf(["x", "y"]).isRequired,
    value: propTypesExports.oneOfType([propTypesExports.number, propTypesExports.string, propTypesExports.instanceOf(Date)]).isRequired,
    lineStyle: propTypesExports.object,
    textStyle: propTypesExports.object
  }))
};
var Ti = memo(Pi),
  Si = ["theme", "renderWrapper", "animate", "motionConfig"],
  Mi = function (e) {
    return function (r) {
      var t, i;
      function n() {
        return r.apply(this, arguments) || this;
      }
      return i = r, (t = n).prototype = Object.create(i.prototype), t.prototype.constructor = t, Mr(t, i), n.prototype.render = function () {
        var r = this.props,
          t = r.theme,
          i = r.renderWrapper,
          n = r.animate,
          o = r.motionConfig,
          a = jr(r, Si);
        return jsx(Ht, {
          theme: t,
          renderWrapper: i,
          isInteractive: a.isInteractive,
          animate: n,
          motionConfig: o,
          children: jsx(e, Sr({}, a))
        });
      }, n;
    }(Component);
  },
  ji = function (e, r) {
    var t,
      i = isFunction_1(e) ? e : function (r) {
        return get_1(r, e);
      };
    return r && (t = isFunction_1(r) ? r : format(r)), t ? function (e) {
      return t(i(e));
    } : i;
  },
  Bi = function (e) {
    return isFunction_1(e) ? e : function (r) {
      return get_1(r, e);
    };
  },
  Gi = function (e) {
    return useMemo(function () {
      return Bi(e);
    }, [e]);
  },
  Ai = function (e, r, t, i, n, o) {
    return e <= n && n <= e + t && r <= o && o <= r + i;
  },
  Fi = function (e, r) {
    var t,
      i = r.clientX,
      n = r.clientY,
      o = e.getBoundingClientRect(),
      a = (t = void 0 !== e.getBBox ? e.getBBox() : {
        width: e.offsetWidth,
        height: e.offsetHeight
      }).width === o.width ? 1 : t.width / o.width;
    return [(i - o.left) * a, (n - o.top) * a];
  },
  Ei = Object.keys(ei),
  Ui = Object.keys(yi),
  Xi = function (e, r, t) {
    if ("*" === e) return !0;
    if (isFunction_1(e)) return e(r);
    if (isPlainObject_1(e)) {
      var i = t ? get_1(r, t) : r;
      return isEqual_1(pick_1(i, Object.keys(e)), e);
    }
    return !1;
  },
  Hi = function (e, r, t, i) {
    var n = void 0 === i ? {} : i,
      o = n.dataKey,
      a = n.colorKey,
      l = void 0 === a ? "color" : a,
      s = n.targetKey,
      d = void 0 === s ? "fill" : s,
      u = [],
      c = {};
    return e.length && r.length && (u = [].concat(e), r.forEach(function (r) {
      for (var i = function () {
          var i = t[n],
            a = i.id,
            s = i.match;
          if (Xi(s, r, o)) {
            var f = e.find(function (e) {
              return e.id === a;
            });
            if (f) if (Ui.includes(f.type)) {
              if ("inherit" === f.background || "inherit" === f.color) {
                var p = get_1(r, l),
                  h = f.background,
                  g = f.color,
                  b = a;
                "inherit" === f.background && (b = b + ".bg." + p, h = p), "inherit" === f.color && (b = b + ".fg." + p, g = p), set_1(r, d, "url(#" + b + ")"), c[b] || (u.push(Sr({}, f, {
                  id: b,
                  background: h,
                  color: g
                })), c[b] = 1);
              } else set_1(r, d, "url(#" + a + ")");
            } else if (Ei.includes(f.type)) {
              if (f.colors.map(function (e) {
                return e.color;
              }).includes("inherit")) {
                var m = get_1(r, l),
                  R = a,
                  q = Sr({}, f, {
                    colors: f.colors.map(function (e, r) {
                      return "inherit" !== e.color ? e : (R = R + "." + r + "." + m, Sr({}, e, {
                        color: "inherit" === e.color ? m : e.color
                      }));
                    })
                  });
                q.id = R, set_1(r, d, "url(#" + R + ")"), c[R] || (u.push(q), c[R] = 1);
              } else set_1(r, d, "url(#" + a + ")");
            }
            return "break";
          }
        }, n = 0; n < t.length; n++) {
        if ("break" === i()) break;
      }
    })), u;
  };
export { Ti as CartesianMarkers, zi as CartesianMarkersItem, Ht as Container, ki as Defs, Wi as DotsItem, Zt as LinearGradient, Vr as MotionConfigProvider, ri as PatternDots, hi as PatternLines, bi as PatternSquares, Jt as ResponsiveWrapper, _i as SvgWrapper, Ft as ThemeProvider, si as absoluteAngleDegrees, Er as annotationsPropType, Gr as axisThemePropType, Hi as bindDefs, zt as blendModePropType, Ct as blendModes, Fr as crosshairPropType, mt as curveFromProp, ct as curvePropKeys, ut as curvePropMapping, jt as defaultMargin, Xr as defaultTheme, yt as defsPropTypes, ni as degreesToRadians, Yr as dotsThemePropType, Kr as extendDefaultTheme, ji as getLabelGenerator, Bi as getPropertyAccessor, Fi as getRelativeCursor, It as getValueFormatter, ei as gradientTypes, Lr as gridThemePropType, Ai as isCursorInRect, Xi as isMatchingDef, Dr as labelsThemePropType, Ir as legendsThemePropType, gt as lineCurvePropKeys, bt as lineCurvePropType, Ar as markersThemePropType, ai as midAngle, Nr as motionConfigContext, Qr as motionDefaultProps, Jr as motionPropTypes, yi as patternTypes, li as positionFromAngle, et as quantizeColorScales, rt as quantizeColorScalesKeys, oi as radiansToDegrees, wt as stackOffsetPropKeys, _t as stackOffsetPropMapping, Rt as stackOrderPropKeys, vt as stackOrderPropMapping, fi as textPropsByEngine, Yt as themeContext, $r as useAnimatedPath, Bt as useDimensions, Gt as useMeasure, Zr as useMotionConfig, Lt as usePartialTheme, Gi as usePropertyAccessor, Et as useTheme, Dt as useValueFormatter, Mi as withContainer };
//# sourceMappingURL=nivo-core.es.js.map
